import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from "@mzc-pdc/ui";
import { IconSetting } from "@mzc-cloudplex/icons";
import menuService from "@services/menuService";
import ListTableBodyCollections from "./list-table-body-collections";
import CollectionColumn from "./list-table-columns-collections";

const ListTableCollections = ({
    selectedItems,
    clickedItem,
    thumbnailCrop,
    hiddenCheckbox,
    isCustomMenu,
    draggable,
    selectedItemsDragging,
    onClickRow,
    onDoubleClickRow,
    onClickDownload,
    onToggleModal,
    onChangeCheck,
    onDragStartItem,
    onDragEndItem,
}) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const { spaceId, projectId } = menuService.parse(pathname);

    const collections = useSelector((store) => store.collections.data);

    return (
        <TableContainer sx={{ overflow: "auto" }}>
            <Table stickyHeader shadowHeader borderHeader sx={{ tableLayout: "fixed" }}>
                <colgroup>
                    {CollectionColumn.filter(({ checked }) => checked).map((column) => (
                        <col
                            key={column.id}
                            style={{
                                ...column.style,
                            }}
                        />
                    ))}
                    <col style={{ width: "72px" }} />
                </colgroup>
                <TableHead>
                    <TableRow>
                        {CollectionColumn.filter(({ checked }) => checked).map((column, index) => (
                            <TableCell key={column.id || index} component="th" sx={{ ...column.style }}>
                                {t(`common::label::${column.label}`)}
                            </TableCell>
                        ))}
                        <TableCell component="th" width={72} align="center">
                            <IconSetting size={15} />
                        </TableCell>
                    </TableRow>
                    <TableRow></TableRow>
                </TableHead>
                <TableBody>
                    {collections ? (
                        <React.Fragment>
                            {collections &&
                                collections.map((collection, idx) => {
                                    return (
                                        <ListTableBodyCollections
                                            key={collection.id}
                                            data={collection}
                                            columns={CollectionColumn.filter(({ checked }) => checked)}
                                            checked={!!selectedItems.find((item) => item.id === collection.id)}
                                            selected={clickedItem === collection.id} //지금 클릭한 애
                                            thumbnailCrop={thumbnailCrop}
                                            hiddenCheckbox={hiddenCheckbox}
                                            isCustomMenu={isCustomMenu}
                                            draggable={draggable}
                                            selectedItemsDragging={selectedItemsDragging}
                                            onClickRow={onClickRow}
                                            onChangeCheck={onChangeCheck}
                                            onDoubleClickRow={() => {
                                                onDoubleClickRow(collection.id);
                                            }}
                                            onClickDownload={onClickDownload}
                                            onToggleModal={onToggleModal}
                                            onDragStartItem={onDragStartItem}
                                            onDragEndItem={onDragEndItem}
                                        />
                                    );
                                })}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <TableRow>
                                <TableCell colSpan={11} className={"text-center"}>
                                    {t(`common::label::Empty {{name}}`, { name: t(`common::label::Collections`) })}
                                </TableCell>
                            </TableRow>
                        </React.Fragment>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ListTableCollections;
